import { Link, Outlet } from "react-router-dom";

import { SiteHeader } from "../ui-kit/site-header";

export function AuthLayout() {
  return (
    <div className="min-h-screen">
      <SiteHeader className="absolute top-0 left-0 w-full bg-transparent sm:hidden" />
      <div className="mx-auto flex h-screen w-full flex-col overflow-hidden sm:flex-row">
        <section className="relative z-10 order-2 -mt-4 flex shrink-0 flex-col justify-center rounded-t-[16px] bg-white p-4 py-8 sm:order-1 sm:mt-0 sm:min-h-0 sm:w-1/2 sm:shrink sm:rounded-none sm:p-10 md:p-14">
          <Link
            to="/"
            className="absolute top-6 left-6 hidden w-fit sm:top-10 sm:left-10 sm:block md:top-14 md:left-14"
          >
            <img src="/logo.svg" alt="Sherpa" className="h-10 w-auto" />
          </Link>
          <Outlet />
        </section>

        <aside className="relative order-1 min-h-0 flex-1 overflow-hidden sm:order-2 sm:w-1/2 sm:flex-none">
          <img
            src="/entrance-img.jpg"
            alt=""
            className="h-full w-full object-cover"
            decoding="async"
            fetchPriority="high"
          />
        </aside>
      </div>
    </div>
  );
}
